import React, { useRef } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useTranslation } from 'react-i18next';
import PODetails from '../PODetails/index';
import LeftSideSection from '../PODetails/LeftSideSection';
import PurchaseOrderRecivingEndDetail from '../PODetails/RecivingEnd/P.O.RecivingEnd';
import EditRequiredAndEnable from '../EditRequiredAndEnable';
import DragDropSort from '../../../../Components/DragDropSort/DragDropSort';
import ImgDropzone from '../../../../Components/ImgDropzone/ImgDropzone';
import { usePOTemplateState } from '../P.O.TemplateContext';
import Loader from '../../../../Components/Utility/Loader/Loader';
import { imageUrl } from '../../../../Components/helper';

function AddEditPOTemplates() {
  const childRef = useRef();
  const {
    showUpload,
    duplicatingItem,
    deleteItem,
    editingInput,
    changeLabel,
    dropLocation,
    dropInLocation,
    handleSaveSequence,
    handleSave,
    deleteCard,
    modfiyReqAndEnable,
    changeData,
    onChangeForData,
    onChange,
    forSwitch,
    imageSrc,
    poState,
    handleShowRearrangeModal,
    redirectToTemplateListing,
    toggleEditPopup,
    setShowUpload,
    setPOState,
  } = usePOTemplateState();
  const { t } = useTranslation('common');

  const handleImageUpload = async (type) => {
    if (type !== 'close') {
      const { imgRes, orgImage } = await childRef.current.showCroppedImg();
      const imageURL = await imgRes;
      const originalImg = await orgImage;
      const rCol = poState.poDetails;
      rCol.image = imageURL?.[0];
      rCol.originalImg = originalImg?.[0];
      setPOState((oldEle) => ({
        ...oldEle,
        poDetails: rCol,
      }));
    }
    setShowUpload(false);
  };

  const ifNotBase64Src = () => {
    return poState?.poDetails?.originalImg ? `${imageUrl}/${poState?.poDetails?.originalImg}` : imageSrc();
  };
  const mainBody = () => {
    return showUpload ? (
      <ImgDropzone
        ref={childRef}
        onSubmit={handleImageUpload}
        image={poState?.poDetails?.originalImg?.includes('base64') ? poState?.poDetails?.originalImg : ifNotBase64Src()}
        acceptedFileExtenstion=".jpeg,.jpg,.png"
        fromPOTemplate
        title={t('PO_TEMPLATES.ADD_MODAL_CHANGES.PO_TEMPLATE')}
        submitButtonName="Upload Image"
      />
    ) : (
      <>
        <div className="page-title-filter sticky">
          <div className="title-container">
            <h4 className="title">{t('PO_TEMPLATES.ADD_MODAL_CHANGES.PAGE_TITLE')}</h4>
          </div>
          <div className="search-filter">
            <button
              className="show-button ml-1"
              type="button"
              name="Rearrange"
              title={t('PO_TEMPLATES.ADD_MODAL_CHANGES.REARRANGE')}
              aria-label={t('PO_TEMPLATES.ADD_MODAL_CHANGES.REARRANGE')}
              onClick={handleShowRearrangeModal}
            >
              <i className="icon-expand m-1" />
            </button>
            <button
              className="show-button d-none d-md-block ml-1"
              type="button"
              name="Save"
              title={t('PO_TEMPLATES.ADD_MODAL_CHANGES.SAVE')}
              onClick={handleSave}
            >
              {t('PO_TEMPLATES.ADD_MODAL_CHANGES.SAVE')}
            </button>
            <button
              className="show-button ml-1"
              type="button"
              name="Cancle"
              title={t('PO_TEMPLATES.ADD_MODAL_CHANGES.CANCEL')}
              onClick={redirectToTemplateListing}
            >
              {t('PO_TEMPLATES.ADD_MODAL_CHANGES.CANCEL')}
            </button>
          </div>
        </div>
        <Container fluid className="position-relative h-100">
          <DndProvider backend={HTML5Backend}>
            <Row className="h-100">
              <Col lg={2} className="border-right color-dark px-0">
                <LeftSideSection leftColumn={poState.leftColumn} />
              </Col>
              <Col className="pt-3" lg={10}>
                <PurchaseOrderRecivingEndDetail data={poState.poDetails} fromForm onChangeForData={onChangeForData} />
                <PODetails
                  data={poState?.rigthColumn}
                  onChange={onChange}
                  modfiyReqAndEnable={modfiyReqAndEnable}
                  deleteCard={deleteCard}
                  fromForm
                  dropLocation={dropLocation}
                  dropInLocation={dropInLocation}
                  duplicatingItem={duplicatingItem}
                  editingInput={editingInput}
                  deleteItem={deleteItem}
                  changeLabel={changeLabel}
                  forSwitch={forSwitch}
                />
              </Col>
            </Row>
          </DndProvider>
          {poState.editPopup && (
            <EditRequiredAndEnable
              toggle={toggleEditPopup}
              data={poState?.editpopupChildData ? poState?.editpopupChildData : poState?.editpopupData}
              dataIndex={poState?.editPopupIndex}
              submit={changeData}
            />
          )}
        </Container>
        {poState.reArrange && (
          <DragDropSort
            isShow={poState.reArrange}
            isToggle={handleShowRearrangeModal}
            fromComp="POTemplate"
            itemList={poState.rigthColumn?.templateJsonSchema}
            saveSequence={handleSaveSequence}
          />
        )}
      </>
    );
  };
  return poState.Loader ? <Loader /> : mainBody();
}

export default AddEditPOTemplates;
